import { render, staticRenderFns } from "./order.vue?vue&type=template&id=6c1787f8&scoped=true"
import script from "./order.vue?vue&type=script&lang=js"
export * from "./order.vue?vue&type=script&lang=js"
import style0 from "./order.vue?vue&type=style&index=0&id=6c1787f8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../szc.cycz.cc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1787f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/szc.cycz.cc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c1787f8')) {
      api.createRecord('6c1787f8', component.options)
    } else {
      api.reload('6c1787f8', component.options)
    }
    module.hot.accept("./order.vue?vue&type=template&id=6c1787f8&scoped=true", function () {
      api.rerender('6c1787f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customerInfo/customerQuotation/order.vue"
export default component.exports